// axios
import axios from "axios";
//component
import { message } from "antd";
// helpers
import {
  clearAuth,
  getAuthenticatedUser,
  getToken,
  getTokenValidStatus,
} from "../auth/auth";
import { pusherService } from "../../services/pusher";

export const axiosInstance = axios.create({
  baseURL: `https://api.mtor.online`,
});

export const salesWebsiteUrl = "https://sales.mtor.online";
export const supplierWebsiteUrl = "https://supplier.mtor.online";

export const A_PARTS_WAREHOUSE_ID = 1098;

//send token with request
axiosInstance.interceptors.request.use(
  function (config) {
    config.headers.Authorization = `Bearer ${getToken()}`;

    const socketId = pusherService.getSocketId();
    if (socketId) {
      config.headers["X-Pusher-Socket-ID"] = socketId;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

//check status code in response
axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (
      (error.response.status === 403 || error.response.status === 401) &&
      getAuthenticatedUser() &&
      getTokenValidStatus()
    ) {
      clearAuth();
      window.location.reload();
    } else if (error.response.status === 400) {
      message.error({
        content: "طلب غير مقبول",
        duration: 3,
        className: "fw-bold",
      });
    } else {
      message.error({
        content: "حدث خطا ما",
        duration: 3,
        className: "fw-bold",
      });
    }

    return Promise.reject(error);
  }
);
